// extracted by mini-css-extract-plugin
export default {"loadMoreButtonContainer":"CustomInfiniteHits-module--load-more-button-container--5f28f"};